import Lottie from 'lottie-react';
import MedeloopLoading from 'src/assets/medeloop-loading.json';

interface LoadingLoopProps {
  className?: string;
}

export const LoadingLoop = ({ className = '' }: LoadingLoopProps) => {
  return <Lottie className={className} animationData={MedeloopLoading} />;
};
